export default __webpack_public_path__ + "static/swiming-pool2-6e700a2be4d4bc549f89f2d51a369bdb.jpg";